import React, { Component } from 'react';
import IconosApp, { Icono } from './IconosApp';
import theme from '../Theme';
import cxs from 'cxs/component';
class FieldIcon extends Component {
    constructor() {
        /*  constructor(props: Props<T>, context: any) {
            super(props, context)
            this.state = {selected: props.icon}
            console.log('props.icon: ', this.state.selected)
          }*/
        super(...arguments);
        this.state = {
            selected: this.props.icon
        };
        this.handleClick = icon => {
            console.log(icon);
            if (this.state.selected === icon) {
                this.setState({ selected: '' });
                this.props.onChange('icon', '', 'icon');
            }
            else {
                this.setState({ selected: icon });
                this.props.onChange('icon', icon, 'icon');
            }
        };
    }
    render() {
        const { icons, onChange } = this.props;
        const { selected } = this.state;
        console.log('render - selected: ', selected);
        return (React.createElement("div", null, icons.map((icon, index) => React.createElement("div", { key: icon, onClick: () => this.handleClick(icon), style: { position: 'relative', display: 'inline-block' } }, selected === icon
            ? (React.createElement("div", null,
                React.createElement(StyledIconosApp, { name: Icono[icon], style: style.selected }),
                React.createElement("div", { style: {
                        fontSize: '12px',
                        textAlign: 'center',
                        border: `1px solid ${theme.color.secondary}`,
                        color: theme.color.primary
                    } }, Icono[icon])))
            : (React.createElement("div", null,
                React.createElement(StyledIconosApp, { name: Icono[icon], style: style.square }),
                React.createElement("div", { style: {
                        fontSize: '12px',
                        textAlign: 'center',
                        border: `1px solid ${theme.color.secondary}`,
                        color: theme.color.secondary
                    } }, Icono[icon])))))));
    }
}
export default FieldIcon;
const StyledIconosApp = cxs(IconosApp)({
/*':hover': {
  color: theme.color.primary
},*/
});
const style = {
    square: {
        /*fontFamily: 'icons',*/
        fontSize: '100px',
        border: `1px solid ${theme.color.secondary}`
        /*color: theme.color.secondary*/
    },
    selected: {
        /*fontFamily: 'icons',*/
        fontSize: '100px',
        border: `1px solid ${theme.color.secondary}`,
        color: theme.color.primary
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldIcon.tsx
// module id = 374
// module chunks = 0